module.exports = new __parcel__URL__("WevrLogoPrimary.a2f6d063.svg").toString();